import { createRouter, createWebHistory } from 'vue-router';
import ResetPassword from './views/ResetPassword.vue';
import { fetchUserInfo } from './services/user';
import ChangePassword from './views/ChangePassword.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Events from './views/Events.vue';
import EventCategories from './views/EventCategories.vue';
import Venues from './views/Venues.vue';
import Register from './views/Register.vue';
import NotificationsMunicipality from './views/NotificationsMunicipality.vue';
import Statistics from './views/Statistics.vue';
import EventPage from './views/EventPage.vue';
import Cart from './views/Cart.vue';
import Scan from './views/Scan.vue';
import UserTickets from './views/UserTickets.vue';
import Users from './views/Users.vue';
import Contact from './views/Contact.vue';
import ThankYou from './views/ThankYou.vue';
import Account from './views/Account.vue';
import Support from './views/Support.vue';
import Terms from './views/Terms.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { layout: 'MainFrontLayout' }
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: { layout: 'MainFrontLayout' }
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms',
    component: Terms,
    meta: { layout: 'MainFrontLayout' }
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    meta: { 
      layout: 'MainLayoutMunicipality',
      requiresAdmin: true 
    },
  },
  {
    path: '/event-categories',
    name: 'EventCategories',
    component: EventCategories,
    meta: { layout: 'MainLayoutMunicipality', requiresAdmin: true  }
  },
  {
    path: '/venues',
    name: 'Venues',
    component: Venues,
    meta: { 
      layout: 'MainLayoutMunicipality',
      requiresAdmin: true
     },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      layout: 'MainFrontLayout' ,
      requiresGuest: true
    },
  },
   {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: 'MainFrontLayout',
      requiresGuest: true
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      layout: 'MainFrontLayout',
      requiresGuest: true
    }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      layout: 'MainFrontLayout',
      requiresAuth: true
    }
  },
  {
    path: '/notifications-municipality',
    name: 'NotificationsMunicipality',
    component: NotificationsMunicipality,
    meta: {
      layout: 'MainLayoutMunicipality',
      requiresAdmin: true
    }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: Statistics,
    meta: {
      layout: 'MainLayoutMunicipality',
      requiresAdmin: true
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      layout: 'MainFrontLayout', requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      layout: 'MainLayoutMunicipality',
      requiresAdmin: true
    }
  },
  {
    path: '/event/:id',
    name: 'EventPage',
    component: EventPage, 
    meta: { layout: 'MainFrontLayout' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart, 
    meta: { layout: 'MainFrontLayout', requiresAuth: true }
  },
  // {
  //   path: '/scan',
  //   name: 'Scan',
  //   component: Scan, 
  //   meta: { 
  //     layout: 'MainFrontLayout', requiresAuth: true
  //   }
  // },
  {
    path: '/tickets',
    name: 'UserTickets',
    component: UserTickets, 
    meta: { 
      layout: 'MainFrontLayout',
      requiresAuth: true
    }
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYou, 
    meta: { 
      layout: 'MainFrontLayout',
      requiresAuth: true
    }
  },
   {
    path: '/account',
    name: 'Account',
    component: Account, 
    meta: { 
      layout: 'MainFrontLayout',
      requiresAuth: true
    }
  },
  
];


const router = createRouter({
  history: createWebHistory(),
  routes
});



let cachedUser = null;
let userChecked = false;

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('api_token');

  // Guest-only pages (keep your logic exactly)
  if (to.meta.requiresGuest && token) {
    if (!userChecked) {
      const response = await fetchUserInfo();

      if (response.status >= 400) { // token invalid/expired
        localStorage.removeItem('api_token');
        userChecked = false;
        cachedUser = null;
        return next(); // allow guest page
      }

      cachedUser = response.data.info;
      userChecked = true;
    }

    return next({ name: 'Home' }); // redirect authenticated
  }

  // Pages that require auth or admin
  const authRequired = to.meta.requiresAuth || to.meta.requiresAdmin;
  if (authRequired) {
    if (!token) return next({ name: 'Login' });

    if (!userChecked) {
      try {
        const response = await fetchUserInfo();
        if (response.status >= 400) throw new Error('Invalid token');
        cachedUser = response.data.info;
        userChecked = true;
      } catch {
        localStorage.removeItem('api_token');
        cachedUser = null;
        userChecked = false;
        return next({ name: 'Login' });
      }
    }

    // Admin check
    if (to.meta.requiresAdmin && cachedUser.usertype_id !== 1) {
      return next({ name: 'Home' });
    }

    return next(); // allow auth page
  }

  // Public pages that require no auth
  return next();
});



export default router;
